export const cn = (...classes: string[]) => classes.filter(Boolean).join(' ');

export * from './formatters';

export const toCents = (amount: number): number => Math.round(amount * 100);
export const toDollars = (cents: number): number => cents / 100;

export const getLocalDate = (timezone: string = 'UTC') => {
  const formatter = new Intl.DateTimeFormat('en-CA', {
     timeZone: timezone,
     year: 'numeric',
     month: '2-digit',
     day: '2-digit'
  });
  return formatter.format(new Date());
};

export const getFormattedTimestamp = (timezone: string = 'UTC') => {
  const date = new Date();
  // Format as YYYY-MM-DD HH:mm:ss in the specified timezone
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(date).replace(',', '');
};

export const parseTransactionDate = (d: any): string => {
  if (!d) return '';
  if (d && typeof d.toDate === 'function') return d.toDate().toISOString().split('T')[0];
  if (typeof d === 'string' && d.includes('/')) {
    const parts = d.split('/');
    if (parts.length === 3) return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
  }
  return typeof d === 'string' ? d.split('T')[0] : '';
};

export const matchesSource = (source: string | undefined, filter: string) => {
    if (filter === 'All') return true;
    if (!source) return false;
    
    // Normalize POS
    if (filter === 'POS' && (source === 'POS' || source === 'POS Override')) return true;
    
    return source.toLowerCase().trim() === filter.toLowerCase().trim();
};
